import { IEnvironment } from './IEnvironment';

export const environment: IEnvironment = {
  production: false,
  msalConfig: {
    auth: {
      clientId: 'fe24118e-5662-4129-b657-d86aba15cee9',
      authority: 'https://hvsidpuat.ciamlogin.com/',
      redirectUri: window.location.origin,
      postLogoutRedirectUri: '/',
      loginFailedRoute: '/login-failed',
    },
    apiConfig: {
      scopes: ['api://63ea4c4c-8774-4c16-b1d6-cdaae0abdc0f/*'],
    },
    sepAdminGroupId: '544ac15d-0f2e-4a75-b624-eeed9f4b6c38',
  },
  backendConfig: {
    baseUrl: 'https://as-securityportal-development.azurewebsites.net/api/v1',
  },
  general: {
    baseUrl: 'https://my-dev.is-fox.com',
    hvsPrivacyPolicyUrl: {
      de: 'https://www.hvs-consulting.de/datenschutzhinweise',
      en: 'https://www.hvs-consulting.de/en/privacy-policy',
    },
    hvsTermsAndConditionsUrl: {
      de: 'https://www.is-fox.com/allgemeine-geschaeftsbedingungen',
      en: 'https://www.is-fox.com/en/general-terms-and-conditions',
    },
    hvsWebflowUrl: 'https://is-fox.webflow.io/plans?employeeNumber=15',
    defaultLang: 'de',
    internationalFallbackLanguage: 'en',
    hvsSupportContactEmail: 'support@is-fox.de',
  },
  analytics: {
    mixpanelProjectToken: '',
    enableAnalytics: false,
  },
  stripe: {
    publicKey:
      'pk_test_51P3KBxRqCu6CCU9LQhAPwiY2JU1UgvjrcsrPNRwm7HXGzj9YDqZA0W0lTz5lxT1I6qjOu7z0RXcMBFEbCyTrySXC00qMyoNWlz',
  },
  productFruits: {
    workspaceId: '71Ds8XGQfFzjug4F',
  },
  unified: {
    workspaceId: '68f8d8305ff51e7f50e04a0c',
    environmentName: 'Development',
    dataRegion: 'eu',
    permissionScopes: ['hris_employee_read', 'hris_group_read'],
  },
  maintenanceMode: false,
};
